import AppStoresQRCodeIcon from 'assets/icons/app_stores_qr_code.svg';
import AppleAppStoreIcon from 'assets/icons/apple_app_store.svg';
import GooglePlayStoreIcon from 'assets/icons/google_play_store.svg';
import { Button } from 'components/Button';
import { APPSTORE_DOWNLOAD_URL, PLAYSTORE_DOWNLOAD_URL } from 'util/constants';

import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

export const DownloadAppModal: React.FC<DialogProps> = ({
  onClose,
  open: isOpen,
  ...props
}) => {
  const handleClose = () => {
    return false;
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      {...props}
    >
      <DialogTitle>
        <Typography variant="h5" fontWeight={500} fontSize={20}>
          Baixar Aplicativo
        </Typography>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ py: 4 }}>
        <Stack direction="row" spacing={2}>
          <Typography
            color="#7A8388"
            fontSize={14}
            fontWeight={400}
            marginTop={1}
          >
            Você pode baixar o aplicativo Vet4all gratuitamente nas lojas de
            aplicativo lendo o QR code com seu celular e aproveitar tudo o que
            temos para oferecer a você e ao seu pet.
          </Typography>

          <Box
            component="img"
            alt="Download App QR Code"
            src={AppStoresQRCodeIcon}
            width={133}
            height={133}
          />

          <Stack
            spacing={1}
            justifyContent="center"
            alignItems="center"
            display="flex"
          >
            <a href={PLAYSTORE_DOWNLOAD_URL} target="blank">
              <Box
                component="img"
                alt="Ícone Google Play Stores"
                src={GooglePlayStoreIcon}
                width={150}
                height={43}
                marginTop={1}
              />
            </a>

            <a href={APPSTORE_DOWNLOAD_URL} target="blank">
              <Box
                component="img"
                alt="Ícone App Store"
                src={AppleAppStoreIcon}
                width={150}
                height={43}
              />
            </a>
          </Stack>
        </Stack>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ pt: 1, pb: 1 }}>
        <Stack spacing={2}>
          <Button variant="text" href="/tutor">
            Ir para login
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
